import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { Pcl } from '../../index';
import { CacheTag } from '../../utils';

import type { Locale } from '@tuic/i18n';

/**
 * Fetches the available ports from the PCL API.
 */
export const getPorts = async (locale: Locale): Promise<Pcl.Port[]> => {
  const { data, error } = await Pcl.getPorts({ query: { locale } });

  if (error) {
    logger.error(`Could not fetch ports. Locale: ${locale}`);
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Fetches the available ports from the PCL API.
 */
export const cachedGetPorts = (locale: Locale): Promise<Pcl.Port[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getPorts', locale]),
    () => getPorts(locale),
    {
      tags: [CacheTag.pcl, CacheTag.portResource, CacheTag.getPorts],
      ttl: 600,
    },
  );
